import { Request } from '@konv/http';
import { EnvironmentStorage } from '../shared/tools/EnvironmentStorage';
import { UserStorage } from '../shared/tools/UserStorage';
import { EnvironmentsAPI } from './EnvironmentsAPI';

export class PaymentHubAPI {

	static async request({ endpoint = '/', method = 'GET', headers = {}, query = {}, data = {} }) {
		return await Request.request({
			endpoint: endpoint,
			method: method,
			headers: headers,
			service: 'payment-hub',
			ignoreVersion: true,
			params: query,
			data: data
		});
	}

	static async requestAuthenticated({ endpoint = '/', method = 'GET', query, data }) {
		return await PaymentHubAPI.request({
			endpoint,
			headers: { 'Authorization': 'Bearer ' + UserStorage.getAccessToken() },
			method,
			query,
			data,
		});
	}

	static async initAccount() {
		const selectedEnvironment = await EnvironmentStorage.getSelectedEnvironment();
		const paymenthubConfigs = await EnvironmentsAPI.getConfigurationsByAlias(selectedEnvironment, 'paymenthub');

		if (paymenthubConfigs.accountId) {
			return paymenthubConfigs;
		}

		const configurations = await EnvironmentStorage.getConfigurations();
		const response = await PaymentHubAPI.request({
			endpoint: '/',
			method: 'POST',
			data: { name: configurations.alias }
		});

		const account = response.getData({});

		const externalCredentials = await EnvironmentsAPI.getConfigurationsByAlias(selectedEnvironment, 'external_credentials');
		externalCredentials.payment_hub = account.api_key;

		await EnvironmentsAPI.putConfigurationsByAlias(selectedEnvironment, 'external_credentials', externalCredentials);

		const paymentHub = {
			accountId: account.id,
			publicKey: account.public_api_key,
			gateways: {}
		}
		await EnvironmentsAPI.putConfigurationsByAlias(selectedEnvironment, 'paymenthub', paymentHub);

		return paymentHub;
	}

	static async getAccountId(environmentId) {
		const paymenthub = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'paymenthub');
		return paymenthub?.accountId;
	}

	static async getGatewayConfiguration(environmentId, gatewayAlias) {
		const externalCredentials = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'external_credentials');
		const paymenthub = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'paymenthub');

		const masterToken = externalCredentials?.payment_hub || externalCredentials?.paymenthub;

		return (await PaymentHubAPI.request({
			endpoint: `/${paymenthub?.accountId}/${gatewayAlias}/configurations`,
			headers: { 'Authorization': 'Bearer ' + masterToken },
		})).getData({})
	}

	static async setGatewayConfiguration(environmentId, gatewayAlias, configuration) {
		const externalCredentials = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'external_credentials');
		const paymenthub = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'paymenthub');
		const masterToken = externalCredentials?.payment_hub || externalCredentials?.paymenthub;

		return await PaymentHubAPI.request({
			endpoint: `/${paymenthub?.accountId}/${gatewayAlias}/configurations`,
			headers: { 'Authorization': 'Bearer ' + masterToken },
			method: 'PUT',
			data: configuration
		})
	}
}
